import React from "react";
import { DEFAULT_VITAL_PREFERENCES } from "../../utils/vitalPreferences";

export default function VitalsFields({
  vitals,
  setVitals,
  vitalPreferences = DEFAULT_VITAL_PREFERENCES,
}) {
  const prefs = vitalPreferences || DEFAULT_VITAL_PREFERENCES;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-12 gap-3">
      {prefs.enableWeight && (
        <div className="sm:col-span-1 xl:col-span-4">
          <label className="block text-xs font-medium text-slate-600 mb-1">Pesha (kg)</label>
          <input
            type="number"
            step="0.1"
            min="0"
            value={vitals.weightKg}
            onChange={(e) => setVitals((p) => ({ ...p, weightKg: e.target.value }))}
            className="input"
          />
        </div>
      )}
      {prefs.enableBloodPressure && (
        <div className="sm:col-span-2 xl:col-span-4">
          <label className="block text-xs font-medium text-slate-600 mb-1">Presioni (mmHg)</label>
          <div className="grid grid-cols-2 gap-2">
            <input
              type="number"
              min="0"
              value={vitals.systolicPressure}
              onChange={(e) => setVitals((p) => ({ ...p, systolicPressure: e.target.value }))}
              className="input"
              placeholder="Sistolike"
              aria-label="Sistolike (mmHg)"
            />
            <input
              type="number"
              min="0"
              value={vitals.diastolicPressure}
              onChange={(e) => setVitals((p) => ({ ...p, diastolicPressure: e.target.value }))}
              className="input"
              placeholder="Diastolike"
              aria-label="Diastolike (mmHg)"
            />
          </div>
        </div>
      )}
      {prefs.enableTemperature && (
        <div className="sm:col-span-1 xl:col-span-2">
          <label className="block text-xs font-medium text-slate-600 mb-1">Temperatura (°C)</label>
          <input
            type="number"
            step="0.1"
            value={vitals.temperatureC}
            onChange={(e) => setVitals((p) => ({ ...p, temperatureC: e.target.value }))}
            className="input"
          />
        </div>
      )}
      {prefs.enableHeartRate && (
        <div className="sm:col-span-1 xl:col-span-2">
          <label className="block text-xs font-medium text-slate-600 mb-1">Rrahjet (bpm)</label>
          <input
            type="number"
            min="0"
            value={vitals.heartRate}
            onChange={(e) => setVitals((p) => ({ ...p, heartRate: e.target.value }))}
            className="input"
          />
        </div>
      )}
    </div>
  );
}
